import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private loading$: Subject<number>;
  loading: Observable<number>;

  constructor() {
    this.loading$ = new Subject<number>();
    this.loading = this.loading$.asObservable();
  }

  sendingRequest(): void {
    this.loading$.next(1);
  }

  receivingRequest(): void {
    this.loading$.next(-1);
  }
}
